{
  "Actions": {
    "actions": "Actions",
    "back": "Back",
    "click here": "Click here",
    "collapse": "Collapse",
    "expand": "Expand",
    "go to vehicle": "Go to vehicle"
  },
  "Alert": {
    "Account is already activated": "Account is already activated.",
    "action failed": "Action failed due to error",
    "add company card success": "New company card successfully added.",
    "add driver success": "Driver successfully added",
    "add integration success": "Integration created successfully.",
    "add vehicle empty imei info": {
      "description": "Vehicle has no IMEI assigned, and will not be able to download files. Add a valid IMEI to download vehicle files.",
      "title": "Vehicle successfully added, but no IMEI assigned."
    },
    "add vehicle success": "Vehicle successfully added",
    "An unhandled error occured while processing this request": "An unhandled error occured while processing this request.",
    "Another driver is registered under this card number.": "Another driver is registered under this card number.",
    "apply all driver schedules success": "Schedule successfully added to all drivers.",
    "apply all vehicle schedules success": "Schedule successfully added to all vehicles.",
    "apply driver schedules success": "Schedule successfully added to {{resourceCount}} drivers.",
    "apply vehicle schedules success": "Schedule successfully added to {{resourceCount}} vehicles.",
    "cancel invitation success": "Invitation successfully canceled.",
    "Card number must be 16 characters in length.": "Driver ID must be 16 characters in length.",
    "CCA file download success": "Company Card Authenticator was successfully downloaded.",
    "Comment must not be longer than 255 characters.": "The number of characters allowed for description is 255.",
    "Company card with such ID already exists.": "Company card with such ID already exists.",
    "Company card with such name already exists.": "Company card with such name already exists.",
    "Company not found": "Company not found.",
    "Company not found.": "Company not found.",
    "Company with this LZ client code already exists.": "Company with this Teltonika code already exists.",
    "create client company success": "New client company successfully created.",
    "create company success": "Company successfully created.",
    "create schedule success": "New schedule successfully created.",
    "credits overdraft activated": "Credit overdraft successfully activated",
    "credits overdraft deactivated": "Credit overdraft successfully deactivated",
    "disable integration success": "Integration successfully disabled.",
    "Driver duplication.": "Driver duplication.",
    "Driver name contains invalid characters.": "Driver name contains invalid characters.",
    "Driver name must be 3-50 characters long.": "Driver name must be 3-50 characters long.",
    "Driver with such card number already exists.": "Driver ID already exists.",
    "Drivers schedules were not found": "Drivers schedules were not found.",
    "edit company card success": "Company card successfully edited.",
    "edit integration success": "Integration successfully edited.",
    "edit schedule success": "Schedule successfully edited.",
    "edit user description": "Changes will take effect after the edited user has logged out.",
    "Email recipient was not found.": "Email recipient was not found.",
    "email transfer edit recipient success": "Email recipient was successfully edited.",
    "email transfer new recipient success": "Email recipient was successfully added.",
    "email transfer remove recipient success": "Email recipient was successfully removed.",
    "enable integration success": "Integration successfully enabled.",
    "error": {
      "import failed": "Failed to import the file. Remove the file, ensure that data matches the required structure and upload the file again.",
      "import failed description": "Remove the file, ensure that data matches the required structure and upload the file again.",
      "import failed title": "Import failed. Data doesn’t match file structure."
    },
    "general settings update success": "Settings successfully changed.",
    "global schedule success": "Global schedule successfully created.",
    "Id must be of digits and letters only": "Id must be of digits and letters only",
    "Id must be of length 6 to 8": "Id must be of length 6 to 8",
    "Imei must be 15 characters long.": "IMEI must be 15 characters long.",
    "Imei must be numeric.": "Only numerical values are allowed for IMEI field.",
    "integration editing cancelled": "Integration editing cancelled.",
    "Integration is disabled. Enable it first before retrying": "Integration is disabled. Enable it first before retrying.",
    "Invalid email address": "Invalid email address.",
    "Invalid format.": "Invalid format of the file",
    "LZ client code not found.": "Teltonika code not found.",
    "move company success": "Company \"{{sourceCompany}}\" was successfully moved to \"{{targetCompany}}\".",
    "New name must be different from the current name.": "New name must be different from the current name.",
    "news created": "News successfully created.",
    "news deleted": "News successfully deleted.",
    "news edited": "News successfully edited.",
    "news published": "News successfully published.",
    "Number must be provided.": "Number must be provided.",
    "Number must not be longer than 30 characters.": "The number of characters allowed for vehicle number is 30.",
    "One or more selected companies have child companies and cannot be deleted.": "One or more selected companies have child companies and cannot be deleted.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "One or more validation errors occured while parsing csv file. Please use template file for reference.",
    "One or more validation errors occured.": "One or more validation errors occured.",
    "quick schedule created": {
      "description": {
        "drivers": "Data download will be initiated as soon as driver connection to TachoSync is identified.",
        "vehicles": "Data download will be initiated as soon as vehicle connection to TachoSync is identified."
      },
      "title": "Quick schedule successfully created.",
      "title multiple drivers": "Quick schedule successfully created for {{driverNum}} drivers.",
      "title multiple vehicles": "Quick schedule successfully created for {{vehicleNum}} vehicles.",
      "title single driver": "Quick schedule successfully created."
    },
    "Quick schedule for vehicle is already created.": "Quick schedule for vehicle is already created.",
    "Quick schedule is already assigned to the driver.": "Quick schedule is already assigned to the driver.",
    "remove company card success": "Company card successfully removed.",
    "resend invitation success": "Invitation was successfully resent.",
    "retry integration success": "Integration \"{{integrationName}}\" connected successfully.",
    "retry interrupted integration success": "Integration \"{{integrationName}}\" will retry syncing skipped files. Please come back later to check the status.",
    "session expired": "Your session has ended. Please sign in again.",
    "successfully activate vehicle multiple": "{{resourceString}} vehicles successfully activated.",
    "successfully activate vehicle single": "Vehicle successfully activated.",
    "successfully assigned schedules": {
      "multiple": "Schedules successfully assigned.",
      "single": "Schedule successfully assigned."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} vehicles successfully deactivated.",
    "successfully deactivate vehicle single": "Vehicle successfully deactivated.",
    "successfully deleted": "{{resourceString}} successfully deleted.",
    "successfully edited": "{{resourceString}} successfully edited.",
    "successfully exported": "$t(General##{{tableName}}) successfully exported.",
    "successfully imported": "{{resourceString}} successfully imported.",
    "successfully move vehicles multiple": "{{resourceString}} have been successfully moved to {{companyString}}.",
    "successfully move vehicles single": "{{resourceString}} has been successfully moved to {{companyString}}.",
    "successfully remove driver schedules multiple": "Schedules were successfully removed from {{resourceString}} drivers.",
    "successfully remove driver schedules single": "Schedules were successfully removed from {{resourceString}} driver.",
    "successfully remove vehicle schedules multiple": "Schedules were successfully removed from {{resourceString}} vehicles.",
    "successfully remove vehicle schedules single": "Schedules were successfully removed from {{resourceString}} vehicle.",
    "successfully removed": "{{resourceString}} successfully removed.",
    "The company with such name already exists.": "The company with such name already exists.",
    "User is already invited.": "User is already invited.",
    "User is not invited": "User is not invited.",
    "Vehicle duplication.": "Vehicle duplication.",
    "Vehicle number contains invalid characters.": "Vehicle number contains invalid characters.",
    "Vehicle schedule was not found": "Vehicle schedule was not found.",
    "Vehicle successfully activated": "Vehicle successfully activated.",
    "Vehicle with such IMEI already exists.": "Vehicle with that IMEI already exists",
    "Vehicle with such Imei number already exists.": "IMEI already exists.",
    "Vehicle with such number (VRN) already exists.": "Vehicle with that VRN already exists",
    "Vehicles schedules were not found": "Vehicles schedules were not found.",
    "You cannot delete a company you are a member of.": "You cannot delete a company which is currently selected. Please select another company and repeat the operation."
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Check your authenticator app",
      "check email": "Check your email",
      "code required": "Verification code required.",
      "code sent to email": "Code sent to your email",
      "code valid": "The code is valid for several minutes.",
      "enter code below": "and enter the code below to sign in."
    },
    "account verification description": "Verification code required. Check your authenticator app and enter the code below to sign in.",
    "authenticator": "Authentication app",
    "authenticator verification description": "Verification code required. Check your authenticator app and enter the code below to sign in.",
    "back to sign in screen": "Back to sign in screen",
    "check email": "Please check your inbox and click the received link to reset a password.",
    "community forum": "Crowd-support forum",
    "contact us": "Contact us",
    "create password": "Create password",
    "did not receive": "Didn’t receive the link?",
    "do not have account": "Don’t have an account yet?",
    "email": "Email",
    "enter current password": "Enter current password",
    "enter email": "Please enter your registered email below to receive password reset instruction.",
    "enter here": "Enter here",
    "enter new password": "Enter new password",
    "enter numbers only": "Please enter numbers only (0-9)",
    "example": "E.g.:",
    "failed to login": "The email address or password you entered is incorrect.",
    "forgot password": "Forgot Password?",
    "forgot your password": "Forgot your password?",
    "go to login": "Go to login",
    "google authenticator": "Google Authenticator",
    "hide password": "Hide password",
    "invalid email format": "Invalid email format",
    "invalid password format": "Invalid password format",
    "Invitation expired": "The invite link has expired or has been canceled.",
    "link sent": "Link has been sent!",
    "login title": "Login",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "New password",
    "password": "Password",
    "password changed": "Password successfully changed.",
    "privacy policy": "By using <1>TachoSync</1>, you agree with our <3>Privacy policy</3>.",
    "remember password": "Do you remember your password?",
    "repeat new password": "Repeat new password",
    "repeat password": "Repeat password",
    "required": "Required",
    "resend": "Resend",
    "reset password": "Reset password",
    "send reset link": "Send reset link",
    "show password": "Show password",
    "sign in": "Sign In",
    "sign in to tacho": "Sign in to your\nTachoSync account",
    "sign out": "Sign out",
    "sign up": "Sign up",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "I understand and accept Teltonika <1>Terms of Service</1> and the <2>Data Processing Agreement</2>.",
    "wiki": "Telematics Wiki Knowledge Base"
  },
  "Button": {
    "accept": "Accept",
    "accept all": "Accept all",
    "accept selected": "Accept selected",
    "actions": "Actions",
    "activate": "Activate",
    "add": "Add",
    "add driver": "Add driver",
    "add integration": "Add integration",
    "add to schedule": "Add to schedule",
    "add vehicle": "Add vehicle",
    "all drivers": "All drivers",
    "all vehicles": "All vehicles",
    "apply": "Apply",
    "assign": "Assign",
    "back": "Back",
    "back to sign in": "Back to Sign in",
    "cancel": "Cancel",
    "change": "Change",
    "child company": "Child company",
    "clear": "Clear",
    "clear all": "Clear all",
    "close": "Close",
    "confirm": "Confirm",
    "continue": "Continue",
    "continue to TachoSync": "Continue to TachoSync",
    "copied": "Copied",
    "copy to clipboard": "Copy to clipboard",
    "create": "Create",
    "create schedule": "Create schedule",
    "deactivate": "Deactivate",
    "default view": "Default view",
    "delete": "Delete",
    "deselect all": "Deselect all",
    "disable": "Disable",
    "don't apply": "Don't apply",
    "download": "Download",
    "edit": "Edit",
    "edit driver": "Edit driver",
    "edit integration": "Edit integration",
    "edit vehicle": "Edit vehicle",
    "enable": "Enable",
    "export": "Export",
    "export drivers": "Export drivers",
    "export vehicles": "Export vehicles",
    "file settings": "File settings",
    "filtered": "Filtered",
    "filters": "Filters",
    "find device": "Find device",
    "finish": "Finish",
    "first page": "First page",
    "generate": "Generate",
    "generate report": "Generate report",
    "get started": "Get started",
    "go back": "Go back",
    "import": "Import",
    "import drivers": "Import drivers",
    "import vehicles": "Import vehicles",
    "inline actions": {
      "cancel invitation": "Cancel invitation",
      "download file driver": "Download",
      "download file vehicle": "Download",
      "download monitoring": "Download monitoring",
      "download status": "Download status",
      "edit analysis provider": "Edit",
      "edit company": "Edit company",
      "edit driver": "Edit driver",
      "edit integration": "Edit integration",
      "edit user": "Edit user",
      "edit vehicle": "Edit vehicle",
      "resend invitation": "Resend invitation",
      "retry analysis provider": "Retry",
      "retry integration": "Retry"
    },
    "invite": "Invite",
    "invite user": "Invite user",
    "history": "History",
    "last page": "Last page",
    "max download files": "You can only download {{maxNumber}} files at one time.",
    "more actions": "More actions",
    "more filters": "More filters",
    "more options": "More options",
    "move": "Move",
    "new client": "New client",
    "next": "Next",
    "next month": "Next month",
    "next page": "Next page",
    "only essential": "Only essential",
    "open TachoSync": "Open TachoSync",
    "pages of": "of {{total}}",
    "pause": "Pause",
    "previous": "Previous",
    "previous month": "Previous month",
    "previous page": "Previous page",
    "quick schedule": "Quick schedule",
    "refresh page": "Refresh page",
    "reject all": "Reject all",
    "remove": "Remove",
    "remove schedules": "Remove schedules",
    "reset": "Reset",
    "reset to default": "Reset to default",
    "resume": "Resume",
    "return home": "Let's go home",
    "rows selected": "{{count}} Selected",
    "save": "Save",
    "schedules": "Schedules",
    "select image": "Select image",
    "select rows": "Select rows",
    "selected": "Selected",
    "send code": "Send code",
    "settings": "Settings",
    "table view": "Table view",
    "testing connection": "Testing connection...",
    "verify": "Verify",
    "yes": "Yes"
  },
  "Company cards": {
    "add new": "Add new",
    "badge tooltip": {
      "Disconnected": "Connection to TachoSync is lost.\nLast connection {{connectionDate}}.",
      "Expired": "The card is deactivated due to it's expiry.",
      "Inactive": "Has never established a successful connection to TachoSync.",
      "Online": "Successfully connected to TachoSync and actively communicating."
    },
    "card expired": "Card has expired: {{date}}",
    "card id": "Card ID",
    "card number": "Card number",
    "card number tooltip": "Card number will be displayed after first successful authorization.",
    "cca version": "CCA version",
    "company card id": "Company card ID",
    "edit card": "Edit card",
    "edit company card": "Edit company card",
    "expiry": "Expiry",
    "expiry date": "Expiry date: {{date}}",
    "expiry tooltip": "Card expiry date will be displayed after first successful authorization.",
    "latest version": "Latest",
    "remove card": "Remove card",
    "remove company card": "Remove company card?",
    "remove company card description": "Are you sure you want to remove the company card “{{cardName}}” ? This action cannot be reverted.",
    "status": "Status",
    "update version warning": "There's a newer version available.  We recommend updating it for the best performance.",
    "valid until": "Valid until",
    "version details after connection is established": "Version details will appear here after the first connection from the company card."
  },
  "Cookies": {
    "accept": "Accept",
    "always active": "Always active",
    "analytics cookies": "Analytics cookies",
    "analytics cookies description": "These trackers are used for analytics help collect data that allows us to understand how users interact with our websites. These insights allow us both to improve content and to build better features that improve the user's experience. This category of cookies can be disabled.",
    "cookie banner message": "We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for other purposes as specified in the <1>cookie policy</1>.",
    "cookie modal title": "We use cookies",
    "cookie policy": "cookie policy",
    "essential cookies": "Essential cookies",
    "essential cookies description": "These trackers are used for activities that are strictly necessary to operate or deliver the service you requested from us and, these cookies do not gather information about you that could be used for marketing purposes and do not remember where you have been on the internet. This category of cookies cannot be disabled.",
    "text": "This website stores data such as cookies to enable necessary site functionality, including analytics."
  },
  "Dashboard": {
    "added": "Added",
    "Available": "Available",
    "cards": "Cards",
    "card tooltips": {
      "connectivity": "<strong>Online:</strong>\nDevice has connected in the last 24 hours\n\n<strong>Offline:</strong>\nDevice has not connected in the last 24 hours\n\n<strong>Inactive:</strong>\nDevice has never established a successful connection with TachoSync",
      "driver downloads": "<strong>On time:</strong>\n0–14 days since last download\n\n<strong>Due soon:</strong>\n15–28 days since last download\n\n<strong>Overdue:</strong>\n29+ days since last download\n\n <strong>No downloads:</strong>\nHas not had any downloads yet",
      "vehicle downloads": "<strong>On time:</strong>\n0–60 days since last download\n\n<strong>Due soon:</strong>\n61–90 days since last download\n\n<strong>Overdue:</strong>\n91+ days since last download\n\n <strong>No downloads:</strong>\nHas not had any downloads yet"
    },
    "cc expiry": {
      "expired": "Expired",
      "near expiry": "Near expiry",
      "near expiry tooltip": "Expiring within 3 months",
      "upcoming expiry": "Upcoming expiry",
      "upcoming expiry tooltip": "Expiring within 3–6 months"
    },
    "company cards": "Company cards",
    "company cards expiration": "Company cards expiration",
    "connectivity": "Connectivity",
    "connectivity tabs": {
      "company cards": "Company cards",
      "devices": "Devices"
    },
    "credit overdraft activated": "Overdraft lets you use up to {{overDraftAmount}} credits beyond your balance.",
    "credits": "Credits",
    "credits health": {
      "Healthy": "Healthy",
      "InOverdraft": "In overdraft",
      "LimitReached": "Limit reached",
      "LowCredits": "Low credits",
      "OverdraftLimitReached": "Limit reached"
    },
    "credits history": "Credits history",
    "credits history actions": {
      "BonusCredits": "Bonus credits",
      "CreditsExpiration": "Credits expiration",
      "Deduction": "Monthly deduction",
      "FreeTrial": "Demo credits added",
      "MonthlyDeduction": "Monthly deduction",
      "Purchase": "Credits added",
      "WebTachoLicenseConversion": "Migration"
    },
    "credits statuses": {
      "available": "Available",
      "balance": "Balance",
      "overdraft": "Overdraft",
      "remaining overdraft": "Remaining overdraft",
      "reserved": "Reserved"
    },
    "Deactivated": "Deactivated",
    "deducted": "Deducted",
    "demo credits": {
      "demo": "Demo",
      "demo credits expired tooltip": "Demo credits have expired. Please purchase credits to continue using TachoSync.",
      "demo credits used up tooltip": "All demo credits have been used. Please purchase credits to continue using TachoSync.",
      "demo info tooltip": "Demo credits are activated upon first IMEI connection and remain active for 90 days."
    },
    "device status": "Device status",
    "devices": "Devices",
    "driver data": "Driver data",
    "driver downloads": "Driver downloads",
    "DueSoon": "Due soon",
    "estimated": "Estimated",
    "expires": "Expires",
    "how credits work": {
      "bottom content": {
        "header": "When is a credit reserved?",
        "table": {
          "body": {
            "any": "Any",
            "any behaviour": "No new credit. Existing reservation holds until month end.",
            "newly assigned": "Newly assigned",
            "newly assigned behaviour": "Reserved on connection. Migrated to VIN after first download.",
            "replaced vin known": "Replaced (VIN known)",
            "replaced vin known behaviour": "No new credit. Existing reservation continues to apply.",
            "none": "None",
            "none behaviour": "No credit reserved. Downloads won't start until a device is assigned."
          },
          "head": {
            "credit behaviour": "Credit behaviour",
            "device": "Device",
            "vehicle status": "Vehicle status"
          }
        }
      },
      "button tooltip": "See how credits work",
      "main description": "TachoSync credits are valid for 12 months. Each new purchase extends the expiry date by another 12 months, ensuring your credits remain available as long as you're active.",
      "main title": "How credits work",
      "middle content": {
        "description": "Your fleet's credit usage reflects exactly how many vehicles are active, based on unique VIN. Devices can be replaced, moved between vehicles, or reassigned across sub-companies without consuming an additional credit, as long as the vehicle's identity is already established.",
        "header": "Credits are reserved per active vehicle, not per device.",
        "read more on wiki": "Read more on Wiki"
      },
      "top content": {
        "active vehicle": "Active vehicle",
        "device can change freely": "Device can change freely",
        "equals one credit": "= 1 credit",
        "identified by IMEI": "Identified by IMEI",
        "identified by VIN": "Identified by VIN",
        "tracking device": "Tracking device"
      }
    },
    "Inactive": "Inactive",
    "last 12 months": "Last 12 months",
    "news": "News",
    "no history to show": "There is no history to show",
    "no news": "No news to show",
    "no results": "No results",
    "NoDownloads": "No downloads",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "On time",
    "Overdue": "Overdue",
    "Remaining": "Remaining",
    "Reserved": "Reserved",
    "response error": "Something went wrong. Try refreshing the page",
    "timeline": "Timeline",
    "tooltip": {
      "click to expand": "Click to expand",
      "connected card expire soon": "Card will expire soon: {{expirationDate}}",
      "disconnected card": "Company card is disconnected.\nLast seen: {{lastSeen}}.",
      "disconnected card expire soon": "Company card is disconnected.\nLast seen: {{lastSeen}}. \n \n Card will expire soon: {{expirationDate}}.",
      "expired card": "Card has expired on {{expirationDate}}.\nReplace the company card with a valid one.",
      "offline card": "Company card is offline.\nLast seen: {{lastSeen}}.",
      "take me there": "Take me there"
    },
    "Upcoming charge": "Upcoming charge",
    "vehicle data": "Vehicle data",
    "vehicle downloads": "Vehicle downloads",
    "view history": "View history"
  },
  "Date picker": {
    "disableFuture": "Date disabled",
    "disablePast": "Date disabled",
    "invalid date format": "Invalid date format",
    "invalidDate": "Invalid date",
    "maxDate": "Wrong date",
    "minDate": "Wrong date",
    "shouldDisableDate": "Date disabled"
  },
  "Details": {
    "activities": "Activities",
    "add new email recipient": {
      "choose a file format": "Choose a file format",
      "enter email": "Enter email",
      "title": "Add new recipient"
    },
    "api company id": "API Company ID",
    "autoAssignGlobalScheduleToDriver": "Assign Global Schedule to new drivers",
    "autoAssignGlobalScheduleToVehicle": "Assign Global Schedule to new vehicles",
    "automaticDriverRegistrationEnabled": "Auto-register new drivers",
    "card holder": "Card holder name",
    "client code": "Client code",
    "close details": "Close details",
    "company": "Company",
    "company cards": "Company cards",
    "company cards limit reached": "You have reached the maximum number of company cards for this company, {{currCount}}/{{maxCount}}.",
    "company settings": "Company settings",
    "Completed": "Completed",
    "connection settings": "Connection settings",
    "creator": "Creator",
    "credits": "Credits",
    "credits overdraft tooltip": "Monthly credit reservation logic is updated to allow negative balance within the account. It will help to have a smoother transition from Web Tacho without pressure on immediate credit purchases.",
    "current status": "Current status",
    "Daily": "Daily",
    "data types": "Data types",
    "deactivated": "Deactivated",
    "deactivated vehicle banner": {
      "description": "This vehicle will not reserve new credits, and the vehicle files cannot be downloaded, until activated.",
      "link": "Activate vehicle",
      "title": "Vehicle is deactivated"
    },
    "detailed speed": "Detailed speed",
    "details": "Details",
    "device imei": "Device IMEI",
    "device status": "Device status",
    "download status": "Download status",
    "download time": "Download time",
    "DownloadPending": "Download pending",
    "driver": "Driver",
    "driver id": "Driver ID",
    "driver status": "Driver status",
    "drivers": "Drivers",
    "edit": "Edit",
    "edit user": "Edit {{userEmail}}",
    "email limit reached": "You have reached the maximum number of emails for this company.",
    "email transfer": "Email transfer",
    "email transfer info tooltip": "The email transfer feature allows you to receive downloaded tachograph data via email. Once a schedule is completed, the system will automatically forward the email to the configured recipients. Each company can add up to {{maxCount}} email recipients.",
    "endpointUrl": "Endpoint URL",
    "events and faults": "Events and faults",
    "Every  days": "Every {{count}} days",
    "Every month": "Every month",
    "EveryDays": "Every {{count}} days",
    "Feature not available in BETA version": "Feature not available in BETA version",
    "file format": "File format",
    "file sync": "File sync",
    "general": "General",
    "host": "Host",
    "imei": "IMEI",
    "included": "Included",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Last activity",
    "last download attempt": "Last download attempt",
    "last successful download": "Last successful download",
    "Never": "Never",
    "next download": "Next download",
    "next download attempt": "Next download attempt",
    "Next download attempt in  day": "Next download attempt in {{count}} day",
    "Next download attempt in  days": "Next download attempt in {{count}} days",
    "no company cards": "No company cards added.",
    "no driver schedule": "Driver has no schedules applied.",
    "no recipients added": "No recipients added",
    "no vehicle schedule": "Vehicle has no schedules applied.",
    "not included": "Not included",
    "on next connection": "On next connection",
    "open files": "Open files",
    "open files disabled tooltip": "This object has no files available.",
    "other": "Other",
    "overview": "Overview",
    "parent company": "Parent company",
    "password": "Password",
    "port": "Port",
    "Quick schedule was completed": "Quick schedule was completed",
    "remotePath": "Remote directory path",
    "remove": "Remove",
    "remove email recipient": {
      "description": "Are you sure you want to remove this email recipient? This action cannot be reverted.",
      "title": "Remove {{userEmail}}?"
    },
    "remove schedule": "Remove schedule",
    "reserved": "Reserved",
    "schedule details": "Schedule details",
    "schedule history": "Schedule history",
    "schedule start time": "Schedule start time",
    "schedules": "Schedules",
    "show less": "Show less",
    "show more": "Show more",
    "show older": "Show older",
    "status": "Status",
    "sub companies": "Sub-companies",
    "technical data": "Technical data",
    "Upon device connection": "On device connection",
    "username": "Username",
    "users": "Users",
    "vehicles": "Vehicles",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "Waiting for device connection",
    "WaitingForScheduleStartTime": "Waiting for schedule start time"
  },
  "Dialog": {
    "account id": "Account ID",
    "account id cannot contain more than": "Account ID cannot contain more than {{maxNumber}} characters",
    "activate vehicles": {
      "description": "Once activated, vehicles might reserve credits based on unique monthly connection. Are you sure you want to activate the following number of vehicles?",
      "title": "Activate vehicles?"
    },
    "add": "Add",
    "add company card": "Add new company card",
    "add driver": "Add driver",
    "add integration": "Add integration",
    "add new integration": {
      "description": "Choose the type of integration you want to add, and configure the details in the next step.",
      "title": "Add new integration"
    },
    "add vehicle": "Add vehicle",
    "add vehicle description": "Add a vehicle by manually filling all the registration details.",
    "add vehicle imei in use accessible": {
      "description": "This IMEI is already linked to another vehicle. Reassigning it will disconnect that vehicle from file downloads. Are you sure you want to continue?",
      "title": "IMEI already in use",
      "vehicle imei": "Vehicle using IMEI \"{{imeiValue}}\":"
    },
    "all resource": "All {{resource}}",
    "api key": "API key",
    "api key placeholder": "Enter API key",
    "api key cannot contain more than": "API key cannot contain more than {{maxNumber}} characters",
    "api key edit": {
      "dialog title": "Edit API key \"{{keyName}}\"",
      "success banner": "API key successfully edited."
    },
    "api key name": "Key name",
    "api key name required": "Key name cannot be empty",
    "api key name too long": "Key name cannot contain more than {{maxNumber}} characters",
    "api management": {
      "description": "Create your API key to securely manage API access to our system, enabling seamless integration with your own software and workflows. TachoSync API documentation can be found ",
      "generated api key": "Generated API key",
      "success banner": "API key was successfully created. Please make sure to save the information below, you will not be able to see it again."
    },
    "cancel invitation": "Cancel invitation",
    "cancel invitation description": "Are you sure you want to cancel the invitation for {{userEmail}}?",
    "card holder name": "Card holder name",
    "card holder name not valid": "Card holder name cannot contain more than {{maxNumber}} characters",
    "card holder name should not be empty": "Card holder name should not be empty",
    "card holder name too short": "Card holder name must contain at least {{minNumber}} characters",
    "card id not valid": "Card id cannot contain more than {{maxNumber}} characters",
    "card id should contain only digits, letters and hyphens": "Card id should contain only digits (0–9), letters A–F, and hyphens (-).",
    "card id should contain only numbers": "Card id should contain only numbers",
    "card id should not be empty": "Card id should not be empty",
    "card id too short": "Card id must contain at least {{minNumber}} characters",
    "card name": "Card name",
    "card name not valid": "Card name cannot contain more than {{maxNumber}} characters",
    "card name should not be empty": "Card name should not be empty",
    "card name too short": "Card name must contain at least {{minNumber}} characters",
    "choose period": "Choose period",
    "client company": "Client company",
    "company": "Company",
    "company card id": "Company Card ID",
    "company name": "Company name",
    "company name in tachoSync": "Company name in TachoSync",
    "company name placeholder": "E.g.: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Allow credit overdraft",
      "auto add new drivers": "Auto-register new drivers",
      "auto add new drivers tooltip": "As soon as a new driver ID is recognised, TachoSync will automatically add it to the drivers table.",
      "auto assign global schedule to drivers": "Auto-assign Global Schedule to new drivers",
      "auto assign global schedule to drivers tooltip": "Automatically applies a Global download schedule to newly registered drivers, ensuring data downloads without manual intervention.",
      "auto assign global schedule to vehicles": "Auto-assign Global Schedule to new vehicles",
      "auto assign global schedule to vehicles tooltip": "Automatically applies a Global download schedule to newly registered vehicles, ensuring data downloads without manual intervention.",
      "auto download driver data": "Auto-download driver data on first connection",
      "auto download driver data tooltip": "Automatically downloads driver card data the first time a driver connects. This ensures capturing full history for new drivers before setting up schedules.",
      "auto update vehicle registration number": "Auto-update vehicle registration number (VRN)",
      "auto update vehicle registration number tooltip": "When enabled, the VRN entered at vehicle creation is overwritten with the value read from tachograph data after the first successful download.",
      "automatic initial vehicle download": "Auto-download vehicle data on first connection",
      "automatic initial vehicle download tooltip": "Automatically downloads vehicle data the first time a vehicle is connected. This ensures capturing full history for new vehicles before setting up schedules.",
      "title": "Company settings"
    },
    "confirm add schedule": "Add schedule?",
    "confirm deactivate api key": {
      "description": "Are you sure you want to deactivate the API key \"{{apiKeyName}}\"?",
      "title": "Deactivate API key?"
    },
    "confirm deactivate integration": {
      "description": "Are you sure you want to deactivate the integration \"{{integrationName}}\"?",
      "title": "Deactivate integration?"
    },
    "confirm delete analysis providers": "Are you sure you want to delete the following number of analysis providers? This action cannot be reverted.",
    "confirm delete api credentials": "Are you sure you want to delete the selected API credentials? This action cannot be reverted, and any API call made using these credentials will be rejected immediately.",
    "confirm delete companies": "Are you sure you want to delete the selected company? This action cannot be reverted.",
    "confirm delete drivers": "This will delete all driver data, but driver files will be kept. Are you sure you want to delete the following number of drivers?",
    "confirm delete integrations": "Are you sure you want to delete the following number of integrations? This action cannot be reverted.",
    "confirm delete users": "Are you sure you want to delete the following number of users? This action cannot be reverted.",
    "confirm delete vehicles": "This will delete all vehicle data, but vehicle files will be kept. Are you sure you want to delete the following number of vehicles?",
    "confirm empty imei": {
      "description": "You have not filled the IMEI field. Vehicles without an IMEI cannot connect to TachoSync, and are not able to download files.\nAre you sure you want to continue?",
      "title": "No IMEI added"
    },
    "convey integration": {
      "add": {
        "description": "Configure your Convey connection",
        "title": "Add convey integration"
      },
      "edit": {
        "description": "Configure your Convey connection",
        "title": "Edit Convey integration"
      },
      "provider settings description": "Make sure to use credentials provided by Convey.",
      "provider settings title": "Provider settings"
    },
    "create": "Create",
    "create company": "Create company",
    "create company main description": "Choose to create a new child company within this hierarchy, or create a new client using a Client LZ code.",
    "create new hierarchy": "Create new hierarchy",
    "create news": "Create news",
    "create news description": "Introduce briefly the content of the modal.",
    "create quick schedule": "Create quick schedule",
    "create schedule": "Create schedule",
    "create schedule description": "Set up automated file downloads by selecting a date, time, and recurrence. The system will handle the downloads for you, ensuring compliance and data accuracy without manual effort. Schedule start time cannot be set in the past.",
    "credits history": {
      "description": "Track your current credits balance and view historical data.",
      "description generate report": "Track your current credits balance, view historical data, and generate a \".csv\" report of all credits consumed within the last 12 months.",
      "generate report description": "Choose any period within the last 12 months, and generate a report of the credits consumed.",
      "generate report title": "Generate report",
      "title": "Credits history"
    },
    "custom period": "Custom period",
    "date display format": "Date display format",
    "date range": "Date range",
    "deactivate vehicle": "Deactivate this vehicle",
    "deactivate vehicle description": "Deactivated vehicles will not reserve new credits and will be blocked from downloading data",
    "deactivate vehicles": {
      "description": "Deactivated vehicles will not reserve new credits, and will be blocked from downloading data.",
      "title": "Deactivate vehicles?"
    },
    "delete": "Delete",
    "delete analysis providers": "Delete analysis providers?",
    "delete api credentials": "Delete API credentials?",
    "delete companies": "Delete companies?",
    "delete companies warning": "Deleting companies action will delete all the resources belonging to those companies.",
    "delete drivers": "Delete drivers?",
    "delete integrations": "Delete integrations?",
    "delete news": "Delete news?",
    "delete news description": "Are you sure you wish to delete the selected news?",
    "delete unpublished release notes": "Delete unpublished release notes?",
    "delete unpublished release notes description": "Are you sure you wish to delete unpublished release notes?",
    "delete users": "Delete users?",
    "delete vehicles": "Delete vehicles?",
    "description": "Description (optional)",
    "description not valid": "Description cannot contain more than {{maxNumber}} characters",
    "description required": "Description",
    "description should not be empty": "Description should not be empty",
    "device imei": "Device IMEI",
    "dialog description": {
      "create company description": "Maximum allowed company levels in a company tree is {{maxNumber}}.",
      "create new hierarchy description": "Maximum allowed company levels in a company tree is {{maxNumber}}. Choose to create a new child company within this hierarchy, or create a new client using a Client LZ code."
    },
    "download activities": "Download activities",
    "download blocked message": "Download blocked - contact your provider to resolve.",
    "download data types": "Download data types",
    "download drivers files": "Download drivers files",
    "download history dialog title": "{{vehicleNumber}} history",
    "download monitoring dialog tooltip": "All data in this view is automatically refreshed every <strong>10 seconds</strong>.\nDevice status reflects the Last connection - not the vehicle's current state.",
    "download only selection": "Only the selected files will be downloaded.",
    "download sample file message": "Download a <1>sample CSV template</1> to see an example of the required format.",
    "download status banners": {
      "CompanyCardExpired": "The company card has expired. Please add a valid company card.",
      "InsufficientCredits": "Insufficient credits. Please add credits in order to download files.",
      "NoCompanyCards": "A company card must be online to start downloading. None are available right now.",
      "NoSchedulesApplied": "This vehicle has no schedules applied.",
      "VehicleDeactivated": "This vehicle is deactivated and cannot begin the download process."
    },
    "download status dialog title": "Download monitoring of {{vehicleNumber}}",
    "download vehicles files": "Download vehicles files",
    "driver file destination": "Driver file destination",
    "driver file destination tooltip": "Select whether driver files will be saved in the folder of the vehicle it was downloaded from or in dedicated driver folders by driver ID.",
    "driver folder": "Driver folder",
    "driver id": "Driver ID",
    "driver id not valid": "Driver ID should contain {{maxNumber}} alphanumeric characters",
    "driver id placeholder": "E.g.: 360896050032309",
    "driver id should not be empty": "Driver ID should not be empty",
    "driver name": "Driver name",
    "drivers folder naming": "Drivers folder naming",
    "edit company": "Edit company \"{{name}}\"",
    "edit driver": "Edit driver \"{{name}}\"",
    "edit news": "Edit news",
    "edit release notes tooltip": "These news are created as Release notes and cannot be changed.",
    "edit user": "Edit user",
    "edit vehicle": "Edit vehicle \"{{name}}\"",
    "edit vehicle imei in use accessible": {
      "description": "This IMEI is already assigned to another vehicle. You can choose to exchange the IMEI’s between the two vehicles, or overwrite IMEI.",
      "title": "IMEI already in use"
    },
    "email": "Email",
    "endpointUrl": "Endpoint URL",
    "endpoint url": "Endpoint URL",
    "endpoint url not valid": "Endpoint URL is not valid",
    "endpoint url placeholder": "Enter URL",
    "enter": "Enter",
    "enter company card id": "Please enter the Company Card ID found inside the Company Card Authenticator application.",
    "enter here": "Enter here",
    "enter name": "Enter name",
    "enter password": "Enter password",
    "enter username": "Enter username",
    "expiration date optional": "Expiration date (optional)",
    "export drivers": {
      "description": "Export all drivers in the selected company to the required .csv files.",
      "include drivers from all companies": "Include drivers from all companies",
      "title": "Export drivers"
    },
    "export vehicles": {
      "description": "Export all vehicles in the selected company to the required .csv files.",
      "include vehicles from all companies": "Include vehicles from all companies",
      "title": "Export vehicles"
    },
    "feature switches": {
      "feature switches": "Feature switches",
      "toggle integrations page": "Enable integrations page"
    },
    "field cannot be changed": "This field cannot be changed",
    "field cannot be empty": "{{fieldName}} cannot be empty",
    "field length not valid": "This field cannot contain more than {{maxNumber}} characters",
    "file format": "File format",
    "filtered resource": "Filtered {{resource}}",
    "filtered drivers": "Filtered drivers",
    "filtered vehicles": "Filtered vehicles",
    "from": "From",
    "future dates": {
      "1 day": "in 1 day",
      "1 minute": "in 1 minute",
      "1 month": "in 1 month",
      "1 week": "in 1 week",
      "1 year": "in 1 year",
      "hours and minutes": "in {{hourCount}}h {{minutesCount}}m",
      "less than a minute": "in <1 minute",
      "multiple days": "in {{daysCount}} days",
      "multiple minutes": "in {{minutesCount}} minutes",
      "multiple months": "in {{monthsCount}} months",
      "multiple weeks": "in {{weeksCount}} weeks",
      "multiple years": "in {{yearsCount}} years"
    },
    "generate api key": {
      "title": "Generate API key"
    },
    "host": "Host",
    "host cannot contain more than": "Host cannot contain more than {{maxNumber}} characters",
    "imei": "IMEI",
    "imei not valid": "IMEI should contain {{maxNumber}} numeric characters",
    "imei placeholder": "E.g.: 360896050032309",
    "imei should not be empty": "IMEI should not be empty",
    "import drivers": "Import drivers",
    "import drivers description": "Add drivers to your list by importing them from a file.",
    "import vehicles": "Import vehicles",
    "import vehicles description": "Add vehicles to your list by importing them from a file.",
    "integration name": "Integration name",
    "integration type": "Integration type",
    "integrations": {
      "deactivate integration": {
        "title": "Deactivate this integration",
        "tooltip": "Temporarily deactivate the integration. You can activate it again by unchecking this option."
      },
      "deactivate api key": "Deactivate API key",
      "deactivate sftp": "Deactivate SFTP",
      "deactivate integration tooltip": "Temporarily deactivate the integration. You can activate it again by unchecking this option.",
      "disable integration": {
        "description": "Are you sure you want to disable the integration \"{{integrationName}}\"?",
        "title": "Disable integration?"
      },
      "driver files info banner": "Please note that driver files downloaded before {{formattedDate}} will be placed in the folder of the most recent vehicle driven by the driver. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Please make sure that your username and password are entered correctly.\nThe integration will be saved with the status \"Failed\" until correct credentials are entered.",
          "title": "Incorrect credentials."
        },
        "FolderCreationFailed": {
          "description": "TachoSync connected to the server, but does not have permission to create folders or upload files to the destination path.\nThe integration will be saved with the status \"Failed\" until the issue is resolved and you retry to connect.",
          "title": "Write access missing."
        },
        "HostUnreachable": {
          "description": "Please make sure that the server address and port are correct and the server is online.\nThe integration will be saved with the status \"Failed\" until the issue is resolved and you retry to connect.",
          "title": "Host unreachable."
        },
        "PathNotFound": {
          "description": "The specified directory could not be located on the server. Please make sure the path is correct.\nThe integration will be saved with the status \"Failed\" until correct path is given.",
          "title": "Path not found."
        },
        "PermissionDenied": {
          "description": "Please make sure that TachoSync has the necessary permissions to access this path.\nThe integration will be saved with the status \"Failed\" until permissions are updated and you retry to connect.",
          "title": "Path permission denied."
        },
        "Unknown": {
          "description": "An unexpected issue occurred while trying to connect to the SFTP server. Please review your server details and settings.\nThe integration will be saved with the status \"Failed\" until the issue is resolved and you retry to connect.",
          "title": "Unexpected error occured."
        }
      },
      "include files from all sub companies": "Include files from all sub-companies",
      "include files tooltip": "When selected, this integration will also fetch files from all sub-companies under your account",
      "include historical files": "Include historical files",
      "include historical files tooltip": "When selected, files downloaded before this integration was created will also be fetched.",
      "select driver files destination": "Select driver files destination"
    },
    "introduce name": "Introduce name",
    "invite user": "Invite user",
    "invite user description": "Once the invite is sent, the user will receive an \nemail with an account creation link. The link will be valid for 7 days.",
    "invite user sent": "User invitation successfully sent.",
    "loading": "Loading...",
    "make release notes": "Make Release notes",
    "make release notes info": "If this field is selected, the news will be published in the Release notes, and the title will be changed to Release notes.",
    "max download files": "Maximum allowed files per one download action - {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Are you sure?",
        "description": "You’re about to move \"{{sourceCompany}}\" to \"{{targetCompany}}\". This action is irreversible, are you sure you wish to continue?"
      },
      "description": "Select a source company and a target company to move it under. The source company and it's resources will be placed under the selected target. This action is irreversible.",
      "error dialog": {
        "description": "Maximum allowed company levels is 4. Moving the selected company here would exceed that limit.",
        "title": "Not possible to move company"
      },
      "info banner": "The source company will retain all its vehicles, drivers, files, companies, users, integrations, and custom schedules. If a global schedule is enabled at the root company level, it will be inherited after the move. If not, existing schedules are kept as-is.",
      "source company": "Source company",
      "sftp warning": "The selected company has a running SFTP server configured. The SFTP connection will be stopped while the company is being moved. Once moving is complete, a new SFTP path will be created and the connection will be resumed.",
      "target company": "Target company",
      "title": "Move company"
    },
    "move vehicles": "Move vehicles",
    "move vehicles info": "Note: Vehicle files will remain in the current company. Download history will be cleared, and download schedules will be removed.",
    "name": "Name",
    "name not valid": "Name cannot contain more than {{maxNumber}} characters",
    "name should not be empty": "Name should not be empty",
    "name too short": "Name must contain at least {{minNumber}} characters",
    "optional": "optional",
    "overwrite imei checkbox": {
      "description": "This option will remove the IMEI from {{vehicleNumber}}.",
      "title": "Overwrite IMEI."
    },
    "parent company": "Parent company",
    "password": "Password",
    "password cannot contain more than": "Password cannot contain more than {{maxNumber}} characters",
    "past dates": {
      "1 month ago": "1 month ago",
      "1 week ago": "1 week ago",
      "1 year ago": "1 year ago",
      "multiple months ago": "{{monthCount}} months ago",
      "multiple weeks ago": "{{weekCount}} weeks ago",
      "multiple years ago": "{{yearCount}} years ago",
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "port": "Port",
    "port must be between": "Port must be between {{minNumber}} and {{maxNumber}} values",
    "previous month": "Previous month",
    "provider": "Provider",
    "publish news": "Publish news?",
    "publish news description": "This news are set to publish. Are you sure you wish to continue? This action cannot be reverted.",
    "publish release notes": "Publish release notes?",
    "publish release notes description": "The release notes are set to publish. Are you sure you wish to continue? This action cannot be reverted.",
    "release notes": "Release notes",
    "remote directory path cannot contain more than": "Remote directory path cannot contain more than {{maxNumber}} characters",
    "remote directory path optional": "Remote directory path (optional)",
    "remove": "Remove",
    "remove schedules": "Remove schedules",
    "remove schedules confirmation description": {
      "drivers multiple": "Are you sure you want to remove {{resourceValue}} schedules from the selected drivers?",
      "drivers single": "Are you sure you want to remove {{resourceValue}} from the selected drivers?",
      "vehicles multiple": "Are you sure you want to remove {{resourceValue}} schedules from the selected vehicles?",
      "vehicles single": "Are you sure you want to remove {{resourceValue}} from the selected vehicles?"
    },
    "remove schedules description": {
      "drivers": "Choose one or more schedules that you wish to remove from the selected drivers.",
      "vehicles": "Choose one or more schedules that you wish to remove from the selected vehicles."
    },
    "resend invitation": "Resend invitation",
    "resend invitation description": "Are you sure you want to resend the invitation for {{userEmail}}?",
    "role": "Role",
    "schedule apply to all": {
      "drivers": "The chosen schedule will be applied to all drivers in the selected company.",
      "vehicles": "The chosen schedule will be applied to all vehicles in the selected company."
    },
    "schedule apply to filtered": {
      "drivers": "The chosen schedule will be applied to filtered drivers using one or more available filters.",
      "vehicles": "The chosen schedule will be applied to filtered vehicles using one or more available filters."
    },
    "schedule apply to selected": {
      "drivers": "The chosen schedule will be applied to all selected drivers using the checkbox.",
      "vehicles": "The chosen schedule will be applied to all selected vehicles using the checkbox."
    },
    "schedule time tooltip description": "If the selected time is in the past, the system will automatically adjust it to the nearest available time in the future.",
    "security settings": "Security settings",
    "security settings description": "Find options that allow you to control how your account is protected.",
    "select": "Select",
    "select a company": "Select a company",
    "select file format example": "Select format (e.g. .DDD)",
    "select format": "Select format",
    "select image": "Select image",
    "select image description": "Select the image you wish to use, by clicking on it and pressing the Save button.",
    "select schedules": "Select schedules",
    "selected resource": "Selected {{resource}}",
    "selected drivers": "Selected drivers",
    "selected vehicles": "Selected vehicles",
    "selected role info message": "<3>Click here</3> to see the detailed table of permissions.",
    "selected role info message title": "Role will determine the users permissions in TachoSync.",
    "sftp integration": {
      "description": "Configure your SFTP connection and define how tachograph files will be structured.",
      "edit title": "Edit SFTP integration \"{{integrationName}}\"",
      "sftp name": "SFTP name",
      "title": "SFTP integration"
    },
    "sftp password": "SFTP password",
    "sftp server hostname or ip": "SFTP server hostname or IP",
    "sftp server port number": "SFTP server port number",
    "sftp server settings": "SFTP server settings",
    "sftp username": "SFTP username",
    "Teltonika code": "Teltonika Code",
    "Teltonika code invalid characters": "Teltonika Code must be {{minCount}}–{{maxCount}} characters long and may include letters, numbers, and dots.",
    "Teltonika code placeholder": "Teltonika Code must be {{minCount}}-{{maxCount}} characters",
    "Teltonika company name": "Company name",
    "time": "Time",
    "time zone": "Time zone",
    "title": "Title",
    "title not valid": "Title cannot contain more than {{maxNumber}} characters",
    "title should not be empty": "Title should not be empty",
    "title too short": "Title must contain at least {{minNumber}} characters",
    "to": "To",
    "toggle children global schedule linking": "Connected to root company Global schedule",
    "toggle children global schedule linking tooltip": "The root company has enabled the inheritance of the Global schedule. To edit the selected company's Global schedule, disable this option. Note that this will disconnect the Global schedule from the root company.",
    "toggle global schedule linking": "Apply Global schedule to all child companies",
    "toggle global schedule linking tooltip": "Enabling this option applies the Global schedule to all child companies. Child companies can disable this option to customize their own Global schedule.",
    "toggle global schedule warning banner": "Some child companies might already be using a different Global schedule. This option will not affect them unless they select it in their Global schedule settings.",
    "unpublished release notes": "There are unpublished release notes.",
    "upload folder blank for root": "Upload folder (blank for root)",
    "username": "Username",
    "username cannot contain more than": "Username cannot contain more than {{maxNumber}} characters",
    "vdo integration": {
      "add": {
        "description": "Configure your VDO Fleet connection.",
        "title": "Add VDO Fleet integration"
      },
      "edit": {
        "description": "Configure your VDO Fleet connection.",
        "title": "Edit VDO Fleet integration"
      },
      "provider settings description": "Make sure to use credentials provided by VDO Fleet.",
      "provider settings title": "Provider settings"
    },
    "vehicle folder": "Vehicle folder",
    "vehicle imei in use inaccessible": {
      "description": "This IMEI is already assigned to a company outside your company group. If a device with this IMEI belongs to you, please contact <supportLink>Teltonika support</supportLink>.",
      "title": "IMEI used by another company group"
    },
    "vehicle name": "Vehicle name",
    "vehicle number": "Vehicle registration number (VRN)",
    "vehicle registration number tooltip": "Auto-update is enabled in your company settings. The VRN you enter here will be overwritten with the value read from tachograph data after the first successful download.",
    "vehicles folder naming": "Vehicles folder naming",
    "vrn": "VRN",
    "vrn should not be empty": "Vehicle registration number should not be empty",
    "welcome to beta version title": "Welcome to TachoSync BETA Testing!"
  },
  "Download history": {
    "download successful": "Download successful",
    "driver data": "Driver data",
    "no history": "History will be displayed here",
    "schedule": "Schedule"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "APDU packet reading error. Device disconnected.",
    "Authenticating": "Authenticating",
    "Authentication failure (02x10)": "Authentication failure (02x10)",
    "Authentication failure after timeout (02x01)": "Authentication failure after timeout (02x01)",
    "Authentication failure after timeout (02x12)": "Authentication failure after timeout (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.",
    "CheckingCredits": "Checking credits",
    "CompanyCardExpired": "Company card expired",
    "CompanyCardInUse": "Company card in use",
    "Could not download any of files": "Could not download any of files",
    "CreditReserved": "Credit reserved",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.",
    "DownloadingDriverData": "Downloading driver data",
    "DownloadingDriverDataFailed": "Downloading driver data failed",
    "DownloadingVehicleData": "Downloading vehicle data",
    "Driver info packet reading error. Device disconnected.": "Driver info packet reading error. Device disconnected.",
    "Failed to download driver data": "Failed to download driver data",
    "Failed to receive APDU from card, timeout exceeded": "Failed to receive APDU from card, timeout exceeded",
    "Failed to receive VUReady packet from device, timeout exceeded": "Failed to receive VUReady packet from device, timeout exceeded",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.",
    "InsufficientCredits": "Insufficient credits",
    "Lost connection with device or card": "Lost connection with device or card",
    "NoCompanyCards": "No company cards",
    "NoDueSchedules": "No due schedules",
    "NoSchedulesApplied": "No schedules applied",
    "ProcessTerminated": "Process terminated",
    "ReceivingDownloadList": "Receiving download list",
    "ReceivingDriverInfo": "Receiving driver info",
    "ReceivingDriversSchedules": "Receiving drivers schedules",
    "ReceivingStatusState": "Receiving status state",
    "ReceivingVehicleSchedules": "Receiving vehicle schedules",
    "requirements": {
      "company card": "Company card",
      "credits available": "Credits available",
      "ignition": "Ignition",
      "ignition unavailable tooltip": "Unknown - last known status was more than 2 hours ago.",
      "imei": "IMEI",
      "schedule assigned": "Schedule assigned",
      "vehicle activated": "Vehicle activated",
      "reason": {
        "CompanyCardExpired": "Company card has expired",
        "IgnitionNotReportedRecently": "Unknown status - ignition state has not been reported recently. Download will still be attempted, but success is less likely",
        "IgnitionOff": "Ignition is off. Download will still be attempted, but success is less likely",
        "InsufficientCredits": "No credits are available",
        "NoCompanyCardOnline": "No company card is currently online",
        "NoCompanyCards": "No company card is currently online",
        "NoImeiAssigned": "The vehicle has no IMEI assigned",
        "NoScheduleAssigned": "Vehicle must have a schedule assigned",
        "VehicleDeactivated": "Vehicle needs to be activated to download data"
      }
    },
    "schedules": {
      "assign schedules": "Assign schedules",
      "assign schedules dialog": {
        "description": "Choose one or more schedules that you wish to assign.",
        "title": "Assign schedules to {{vehicleNumber}}"
      },
      "fail reason": {
        "download requirements not met": "download requirements not met."
      },
      "no schedules assigned": "This vehicle has no schedules assigned",
      "on device connection": "on device connection",
      "requirements not met": "Schedule cannot be executed until all requirements are met."
    },
    "StageComplete": "Stage complete",
    "Stages": {
      "Authentication": "Authentication",
      "Downloading": "Downloading",
      "DownloadTrigger": "Download trigger",
      "Initialization": "Initialization"
    },
    "Status packet reading error. Device disconnected.": "Status packet reading error. Device disconnected.",
    "TerminatingConnectionToDevice": "Terminating connection to device",
    "Timeout. Response from VU not received (02x01)": "Timeout. Response from VU not received (02x01)",
    "Too many KeepAlive packets received.": "Too many KeepAlive packets received.",
    "Unexpected error": "Unexpected error",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.",
    "UploadingDriverFiles": "Uploading driver files",
    "UploadingDriverFilesFailed": "Uploading driver files failed",
    "UploadingVehicleFiles": "Uploading vehicle files",
    "UploadingVehicleFilesFailed": "Uploading vehicle files failed",
    "VehicleDeactivated": "Vehicle deactivated",
    "VuNotReady": "VU not ready. Retrying in 5 min",
    "VU ready packet reading error. Device disconnected.": "VU ready packet reading error. Device disconnected.",
    "WaitingForDeviceConnection": "Waiting for device connection",
    "Wrong communication command": "Wrong communication command"
  },
  "Drivers": {
    "drivers page": "Drivers",
    "last activity": {
      "Available": "Available",
      "BreakOrRest": "Break/Rest",
      "Drive": "Driving",
      "NotAvailable": "Not available",
      "Undefined": "N/A",
      "Unknown": "Unknown",
      "Unknown4": "Unknown",
      "Unknown5": "Unknown",
      "Work": "Work"
    }
  },
  "Dropzone": {
    "add file": "Add file",
    "drop file to upload": "Drop the file to upload",
    "drop files to upload": "Drop files to upload",
    "error uploading the file": "There was an error uploading the file",
    "file invalid type": "Invalid file type selected.",
    "file successfully uploaded": "File successfully uploaded",
    "file syntax": "File syntax is as follows:",
    "maximum file limit reached": "The maximum file limit reached.",
    "no image": "No image",
    "only one file can be attached": "Only one file can be attached.",
    "or drop file to upload": "Or drop file to upload",
    "or drop files to upload": "Or drop files to upload",
    "row limit exceeded": "Resource import limit reached. You can not import more than {{rowLimit}} resources.",
    "rows detected": "Rows in the file successfully detected",
    "select file": "Select file",
    "select file type": "Please select the file type first.",
    "select files": "Select files",
    "select image": "Select image:",
    "supported formats": "Supported formats",
    "too long file name": "File name is too long. Max {{maxLength}} characters allowed.",
    "too many files description": "The rest of the files can be uploaded after you upload the selected files.",
    "too many files title": "There is a maximum file limit of {{maxFiles}} you can attach at once."
  },
  "Error": {
    "error": "Error",
    "message wait": "Brace yourself till we get the error fixed.",
    "title": "Something went wrong!"
  },
  "Files": {
    "files header info tooltip": "Downloaded files are stored in TachoSync for two years, after which they're automatically removed from the system."
  },
  "Filter": {
    "company": "Company",
    "credit status": "Credit status",
    "deactivatedVehicles": "Deactivated vehicles",
    "device imei": "Device IMEI",
    "device status": "Device status",
    "driver": "Driver",
    "filtered by": "Filtered by",
    "filters used": "Filters used",
    "from to date": "{{fromDate}} to {{toDate}}",
    "last activity": "Last activity",
    "last download": "Last download",
    "last download options": {
      "DueSoon": "Due soon",
      "NoDownloads": "No downloads",
      "OnTime": "On time",
      "Overdue": "Overdue",
      "Undefined": "N/A"
    },
    "more filters": "More filters",
    "noDeviceImei": "No device IMEI",
    "Not reserved": "Not reserved",
    "Reserved": "Reserved",
    "schedule": "Schedule",
    "schedule name": "Schedule name",
    "schedules": "Schedules",
    "select date": "Select date",
    "select date and time": "Select date and time",
    "Select date range": "Select date range",
    "status": "Status",
    "table filters": "Table filters",
    "vehicle number": "Vehicle number"
  },
  "General": {
    "Active": "Active",
    "Administrator": "Administrator",
    "administrator role description": "Full control to create, edit, and delete all resources.",
    "analysis provider": "Analysis provider",
    "analysis providers": "Analysis providers",
    "api credential": "API credential",
    "api credentials": "API credentials",
    "Available": "Available",
    "Awaiting connection": "Awaiting connection",
    "badge": {
      "connected badge tooltip text": "Successfully connected to TachoSync and actively communicating.",
      "deactivated badge tooltip text": "This vehicle is deactivated and will not consume credits.",
      "inactive badge tooltip text": "Has never established a successful connection with TachoSync.",
      "offline badge tooltip text": "Hasn't connected to TachoSync in the last 24 hours",
      "online badge tooltip text": "Connected in the last 24 hours"
    },
    "Blocked": "Blocked",
    "BreakOrRest": "Break/Rest",
    "business": "Business",
    "code expired": "Your sign-in session has expired. Please sign in again.",
    "column": "Column",
    "companies": "Companies",
    "company": "Company",
    "Company administrator": "Company administrator",
    "Connected": "Connected",
    "credits": "Credits",
    "dashboard": "Dashboard",
    "Deactivated": "Deactivated",
    "Description": "Description",
    "Disabled": "Disabled",
    "Disconnected": "Disconnected",
    "Drive": "Driving",
    "driver data": "Driver data",
    "drivers": "Drivers",
    "DueSoon": "Due soon",
    "end": "End",
    "Expired": "Expired",
    "Failed": "Failed",
    "files": "Files",
    "here": "here",
    "history": "History",
    "Inactive": "Inactive",
    "in progress": "in progress",
    "integration": "Integration",
    "integrations": "Integrations",
    "integrations/analysisProviders": "Analysis providers",
    "integrations/apicredentials": "API credentials",
    "Interrupted": "Interrupted",
    "InvalidConfiguration": "Failed",
    "invitations": "Invitations",
    "latest version": "Latest version",
    "menu": "Menu",
    "NoDownloads": "No downloads",
    "not assigned": "Not assigned",
    "Not reserved": "Not reserved",
    "NotAvailable": "Not available",
    "NotReserved": "Not reserved",
    "Offline": "Offline",
    "Online": "Online",
    "OnTime": "On time",
    "Pending": "Pending",
    "requirements": "Requirements",
    "Reserved": "Reserved",
    "row": "Row",
    "schedule": "Schedule",
    "schedules": "Schedules",
    "show older": "Show older",
    "start": "Start",
    "Successful": "Successful",
    "Teltonika support": "Teltonika support",
    "Teltonika Support": "Teltonika support",
    "teltonika support role description": "Specialized access for technical support.",
    "Tooltip": {
      "accept beta terms": "To continue, scroll to the bottom and accept the terms."
    },
    "unauthorized": "Failed to authenticate user",
    "Undefined": "N/A",
    "Unknown": "Unknown",
    "Unknown4": "Unknown",
    "Unknown5": "Unknown",
    "User": "User",
    "user role description": "Basic access with limited permissions.",
    "users": "Users",
    "vehicles": "Vehicles",
    "Work": "Work",
    "year": "Year"
  },
  "Languages": {
    "english": "English",
    "french": "French",
    "language": "Language"
  },
  "Navigation": {
    "collapse menu": "Collapse menu",
    "expand menu": "Expand menu"
  },
  "News": {
    "create news": "Create news",
    "delete": "Delete",
    "edit": "Edit",
    "publish": "Publish",
    "unpublished": "Unpublished"
  },
  "Notifications": {
    "notifications": "Notifications"
  },
  "Password": {
    "account password": "Account password",
    "are you sure": "Are you sure?",
    "change": "Change",
    "change password": "Change password",
    "click to scan code": "Click here to scan a QR code instead",
    "click to type code": "Click here to manually type the code instead",
    "disable description confirmation": "You’re about to disable your two-factor authentication. This might make your TachoSync account unsecure. Are you sure you want to continue?",
    "disable description send code": "A 6-digit code has been sent to your authentication app. For security purposes, please enter the generated code in the field below.",
    "disable description send password": "For security purposes, please re-enter your current password.",
    "disable no access": "If you no longer have access to the authenticator app linked to this account, a password change is needed to disable the two-factor authentication.",
    "disabled": "Disabled",
    "disabled two FA": "Two-factor authentication successfully disabled.",
    "enabled": "Enabled",
    "enter": "Enter",
    "enter current password": "Enter current password",
    "generate key description": "You will need an authenticator mobile app to complete this process, such as one of the following:",
    "incorrect code": "Incorrect code",
    "incorrect password": "Incorrect password",
    "lowercase letter": "At least one lowercase letter (a-z)",
    "minimum characters": "At least {{maxNumber}} characters",
    "minimum digits": "At least one number",
    "password": "Password",
    "password too long": "Password cannot contain more than {{maxNumber}} characters",
    "passwords must match": "Passwords must match",
    "reset password success": "Your password has been changed.",
    "scan QR code": "Scan the QR code into your app",
    "six digit code": "6-digit code generated by your app",
    "special character": "At least one special symbol (!@#$%^&*()-_=+)",
    "success description": "You’ve successfully enabled two-factor authentication.",
    "two-factor authentication": "Two-factor authentication",
    "two-factor authentication description": "Two-factor authentication is an extra layer of security that verifies your identity with something you know (password) and something you have (phone, security key).",
    "two-factor authentication enabled": "Two-factor authentication successfully enabled.",
    "two-factor authentication status": "Two-factor authentication is:",
    "type text code": "Type the text code into your app",
    "uppercase letter": "At least one uppercase letter (A-Z)"
  },
  "Schedules": {
    "activities from": "Activities from",
    "activities to": "Activities to",
    "apply button tooltip": "Select at least one {{resourceName}} and schedule to Apply.",
    "confirm bulk quick schedule": "You are about to create a Quick schedule for the selected drivers. Do you wish to continue?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "You have drivers selected, but no schedule has been chosen or applied. Are you sure you want to continue?",
          "selected": "You have selected a schedule, but didn’t apply it. Do you wish to apply the schedule to the selected drivers?"
        },
        "vehicles": {
          "not selected": "You have vehicles selected, but no schedule has been chosen or applied. Are you sure you want to continue?",
          "selected": "You have selected a schedule, but didn’t apply it. Do you wish to apply the schedule to the selected vehicles?"
        }
      },
      "title": {
        "not selected": "No schedule chosen or applied.",
        "selected": "Schedule not applied."
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Are you sure want to delete “{{scheduleName}}” schedule? This action is irreversible and will affect all drivers that have this schedule applied.",
        "vehicles": "Are you sure want to delete “{{scheduleName}}” schedule? This action is irreversible and will affect all vehicles that have this schedule applied."
      },
      "title": "Delete schedule?"
    },
    "create new schedule": "Create new schedule",
    "data types": "Data types",
    "days": "days",
    "details remove schedule": {
      "description": "Are you sure you want to remove the schedule “{{scheduleName}}”",
      "title": "Remove schedule?"
    },
    "download activities": {
      "date info tooltip": "Activity date range must span at least two days.",
      "tooltip text": "TachoSync uses adaptive activities download range ensuring continuity by automatically adjusting the download period based on the last successful data retrieval. This minimizes gaps and ensures you always have the latest data, even if a scheduled download is not completed for a couple of days."
    },
    "driver number": "Driver {{driverNum}}",
    "driver schedules": {
      "description": "Driver schedules allow you to automate tachograph data downloads for selected drivers. Select the drivers you wish to apply a schedule to. Choose a schedule from the list and click ‘Apply’ to activate it. You can create, edit, and delete schedules as needed. Note: Each company can have a maximum of 3 driver schedules at a time.",
      "description read-only": "Driver schedules allow you to automate tachograph data downloads for selected drivers. Company administrators can create, edit, and delete schedules as needed.",
      "title": "Driver schedules"
    },
    "due date": "Due date",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "Global schedule will automatically be applied to all newly added drivers. This can be changed in the general settings.",
          "not global": "Changes made to this schedule will affect all drivers that have the schedule applied."
        },
        "vehicles": {
          "global": "Global schedule will automatically be applied to all newly added vehicles. This can be changed in the general settings.",
          "not global": "Changes made to this schedule will affect all vehicles that have the schedule applied."
        }
      },
      "title": {
        "global": "Global schedule",
        "not global": "Edit schedule"
      }
    },
    "enter days": "Enter days",
    "every": "Every",
    "fail reason": "Fail reason",
    "file types": {
      "Activities": "Activities",
      "DetailedSpeed": "Detailed speed",
      "EventsAndFaults": "Events and faults",
      "Overview": "Overview",
      "TechnicalData": "Technical data"
    },
    "global schedule": {
      "connected to root company": "Connected to the root company Global schedule.",
      "global icon info": "Global schedule will automatically apply to all newly registered {{specificGlobalSchedule}}. You can disable this option in the company settings.",
      "info": {
        "edit driver schedule": "Global schedule will automatically apply to all newly registered drivers. You can disable this option in the company settings.",
        "edit schedule": "Global schedule will automatically apply to all newly registered {{ variableName }}. You can disable this option in the company settings.",
        "edit vehicle schedule": "Global schedule will automatically apply to all newly registered vehicles. You can disable this option in the company settings."
      },
      "inherited settings": "Root company Global schedule settings are automatically inherited by all child companies.",
      "not configured description": "Press the Edit button to start configuring Global schedule.",
      "not configured description read-only": "Details of the schedule will appear once it's configured.",
      "not configured title": "Global schedule not configured.",
      "not connected to root company": "Not connected to the root company Global schedule."
    },
    "include driver data": "Include driver data",
    "include driver data tooltip": "Select whether the quick schedule should also download driver card data for the driver(s) currently inserted in the tachograph at the time of execution.\n<ul><li>None – Only vehicle (VU) data will be downloaded.</li><li>Driver 1 / Driver 2 – Download data from the selected tachograph slot if a driver card is present.</li><li>Both drivers – Download data from both slots if cards are present.</li></ul>If no driver card is inserted in the selected slot during execution, driver data will not be downloaded.",
    "max number reached": "You’ve reached the maximum number of allowed schedules.",
    "name not valid": "Schedule name cannot contain more than {{maxNumber}} characters",
    "next attempt": "Next attempt",
    "next date": "Next date",
    "next date and time": "Next date and time",
    "next due date": "Next due date",
    "quick schedule": {
      "description": "Choose data types you wish to download.",
      "driver schedule quick download new": "Creates a one-time schedule for driver file download. It will be executed as soon as the driver connects to the application.",
      "info banner": {
        "drivers": "This is a one time schedule. Driver data download will be initiated as soon as driver connection to TachoSync is identified.",
        "vehicles": "This is a one time schedule. Vehicle data download will be initiated as soon as vehicle connection to TachoSync is identified."
      },
      "success banner": "Schedule was completed, it can be removed by clicking 'Remove schedule'",
      "title": "Quick schedule",
      "vehicle schedule quick download deactivated": "Quick schedule cannot be initiated on deactivated vehicles. If you wish to start a new quick schedule, first activate the vehicle.",
      "vehicle schedule quick download new": "Creates a one-time schedule for vehicle file download. It will be executed as soon as the vehicle connects to the application."
    },
    "repeat": "Repeat",
    "repeat every": "Repeat every",
    "repeat period": {
      "Biweekly": "Every 14 days",
      "Custom": "Custom",
      "Daily": "Daily",
      "Every28Days": "Every 28 days",
      "Every90Days": "Every 90 days",
      "EveryDays": "Every {{count}} days",
      "Hourly": "Hourly",
      "Monthly": "Monthly",
      "Weekly": "Every 7 days"
    },
    "schedule details": "“{{scheduleName}}” details",
    "select date": "Select date",
    "start date": "Start Date",
    "start date and time": "Start date and time",
    "vehicle schedules": {
      "description": "Vehicle schedules allow you to automate tachograph data downloads for selected vehicles. Select the vehicles you wish to apply a schedule to. Choose a schedule from the list and click ‘Apply’ to activate it. You can create, edit, and delete schedules as needed. Note: Each company can have a maximum of 3 vehicle schedules at a time.",
      "description read-only": "Vehicle schedules allow you to automate tachograph data downloads for selected vehicles. Company administrators can create, edit, and delete schedules as needed.",
      "download data activities tooltip hourly": "Activities will be downloaded for the current day",
      "download data activities tooltip monthly": "Activities will be downloaded for the full past month prior to each run date",
      "download data activities tooltip multiple": "Activities will be downloaded for the last {{repeatDays}} days prior to each run date",
      "download data activities tooltip single": "Activities will be downloaded for the last day prior to each run date",
      "title": "Vehicle schedules"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "IMEI must consist of 15 characters",
      "find device": "Find device",
      "no vehicle found": "No vehicle found",
      "no vehicle found description": "Vehicle not found. Please try typing a different device IMEI.",
      "only numbers": "Only numbers are valid",
      "search for vehicles by their IMEI": "Search for vehicles by their device IMEI",
      "search vehicle IMEI": "Search device IMEI"
    },
    "search": "Search...",
    "search child company": "Search child company",
    "search company name": "Search company name",
    "search in driverFiles": "Search by Driver or Driver ID",
    "search in drivers": "Search by name or Driver ID",
    "search in integrations": "Search by name",
    "search in users": "Search by email",
    "search in vehicleFiles": "Search by FM device IMEI or VRN",
    "search in vehicles": "Search by FM device IMEI or VRN"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Use that code on the next screen to verify your account.",
        "description modal": "Use that code to verify your account.",
        "title": "By pressing \"Send code\", a unique code will be sent to <1>{{email}}</1>."
      },
      "select authentication type": {
        "authentication app description": "Get a unique code from an app like Microsoft Authenticator, or Google Authenticator.",
        "description": "To keep your account and client data secure, please use one of the following options to setup Two-Factor Authentication.",
        "description modal": "Select your preferred authenticator method.",
        "email": "Email",
        "email description": "We will send a one-time code to your email whenever you try to sign in.",
        "recommended": "Recommended",
        "title": "Two-factor Authentication (2FA) is mandatory for all TachoSync users.",
        "title modal": "Select authentication method"
      },
      "send email code": {
        "description": "Please enter the code in the field below, and press \"Verify\" to proceed.",
        "enter code": "Please enter the code to verify the email.",
        "title": "A unique code was sent to <1>{{email}}</1>.",
        "verification code": "Verification code"
      },
      "send otp code": {
        "click to scan code": "Click here to scan a QR code instead",
        "click to type code": "Click here to manually type the code instead",
        "incorrect code": "Incorrect code",
        "scan QR code": "Scan the QR code into your app",
        "six digit code": "6-digit code generated by your app",
        "title": "You will need an authenticator mobile app to complete this process, such as: <1>Microsoft Authenticator</1> or <2>Google Authenticator</2>.",
        "type text code": "Type the text code into your app"
      },
      "success message": {
        "alert": "Two-factor authentication successfully enabled.",
        "description": "We will ask for an authentication code any time you log in with your email and password.",
        "title": "You have successfully enabled two-factor authentication.",
        "title modal": "Two-factor authentication Enabled!"
      },
      "title": {
        "authentication app": "Authentication app",
        "authentication email": "Authentication email",
        "is enabled": "Two-factor authentication enabled.",
        "protect your account": "Protect your TachoSync account"
      }
    }
  },
  "Selector": {
    "client company": "Client company",
    "companies": "Companies ({{companyCount}})",
    "company selector": "Company selector"
  },
  "Settings": {
    "CCA file size": "File size 83,5 MB",
    "change password": "Change password",
    "company card authenticator": "Company Card Authenticator",
    "email notifications": {
      "credits purchased": "Credits purchased",
      "low credits alerts": "Low credits alerts",
      "title": "Email notifications",
      "tooltip": "Manage which credit-related emails you receive."
    },
    "feature switches": "Feature switches",
    "file format settings": {
      "description": "Choose in which format tachograph files should be displayed. Possible formats are European (.DDD), French (.V1B for vehicle data and .C1B for driver data) and Spanish (.TGD).",
      "title": "File format settings"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "General settings",
    "security": "Security",
    "time settings": {
      "date display format tooltip": "Select a format of displaying the date inside TachoSync.\nE.g.: DD-MM-YYYY = 14-05-2024",
      "description": "Set time zone automatically using your current location, or choose your preferred time zone and the format in which all timestamps will be displayed.",
      "time and date format toggle": "Set time and date format automatically",
      "title": "Time settings"
    },
    "tutorials": "Tutorials",
    "version": "Version"
  },
  "Table": {
    "activity period": "Activity period",
    "Automatic initial Driver Download": "Automatic initial Driver Download",
    "Automatic initial Vehicle Download": "Automatic initial vehicle download",
    "card name": "Name",
    "card number": "Driver ID",
    "cardnumber": "Driver ID",
    "comment": "Comment",
    "company": "Company",
    "connection status": "Connection status",
    "created at": "Created at",
    "created by": "Created by",
    "credit status": "Credit status",
    "data types": "Data types",
    "day ago": "1 day ago",
    "days ago": "{{daysNum}} days ago",
    "description": "Description",
    "device imei": "Device IMEI",
    "device imei empty": "The vehicle has no IMEI added. A valid IMEI is necessary for device connection and file download. Go to edit vehicle, and add a valid IMEI to allow vehicle file download.",
    "device status": "Device status",
    "downloaded at": "Downloaded at",
    "driver": "Driver",
    "driver name": "Driver name",
    "drivers name": "Drivers name",
    "email": "Email",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Add integration",
          "driver files": "Add driver file",
          "drivers": "Add driver",
          "integrations": "Add integration",
          "integrations api": "Add integration",
          "users": "Invite user",
          "vehicle files": "Add vehicle file",
          "vehicles": "Add vehicle"
        },
        "reset view": "Reset view"
      },
      "no initial results": {
        "description": {
          "analysis providers": "As soon as analysis providers are added to TachoSync, \nyou will be able to see the list here.",
          "companies": "As soon as companies are added to TachoSync,\nyou will be able to see the list here.",
          "company cards": "As soon as company cards are added, you will be able to see the list here.",
          "driver files": "As soon as driver files are added to TachoSync,\nyou will be able to see the list here.",
          "drivers": "As soon as drivers are added to TachoSync,\nyou will be able to see the list here.",
          "integrations": "As soon as integrations are added to TachoSync, \nyou will be able to see the list here.",
          "integrations api": "As soon as API keys are added to TachoSync,\nyou will be able to see the list here.",
          "users": "As soon as users are added to TachoSync, you \nwill be able to see the list here.",
          "users invitations": "As soon as users are invited to TachoSync,\nyou will be able to see the list here.",
          "vehicle files": "As soon as vehicle files are added to TachoSync,\nyou will be able to see the list here.",
          "vehicles": "As soon as vehicles are added to TachoSync,\nyou will be able to see the list here."
        },
        "title": {
          "analysis providers": "No analysis providers yet",
          "companies": "Companies table is empty",
          "company cards": "Company cards table is empty",
          "driver files": "Driver files table is empty",
          "drivers": "Drivers table is empty",
          "integrations": "No integrations yet",
          "integrations api": "No API keys yet",
          "users": "Users table is empty",
          "users invitations": "User invitations table is empty",
          "vehicle files": "Vehicle files table is empty",
          "vehicles": "Vehicles table is empty"
        }
      },
      "no results found": {
        "description": "Try a different keyword or filter, for more \nresults.",
        "title": "No results found"
      }
    },
    "enable": "Enable",
    "expiration date": "Expiration date",
    "expired integration tooltip": "The integration has expired and cannot be enabled",
    "file name": "File name",
    "Global schedule": "Global schedule",
    "imei": "IMEI",
    "invitation status": "Invitation status",
    "invited at": "Invited at",
    "invited by": "Invited by",
    "last activity": "Last activity",
    "last connected": "Last connected",
    "last connection": "Last connection",
    "last download": "Last download",
    "last download date": "Last download: {{date}}",
    "last event": "Last event",
    "last vehicle used": "Last vehicle used",
    "method": "Method",
    "name": "Name",
    "next download": "Next download",
    "No schedule applied": "No schedule applied",
    "No schedules": "No schedules",
    "number": "Number",
    "Overdue": "Overdue",
    "parent company": "Parent company",
    "plate number": "Plate number",
    "provider": "Provider",
    "Quick schedule": "Quick schedule",
    "role": "Role",
    "rows per page": "Rows per page",
    "schedule": "Schedule",
    "schedules": "Schedules",
    "seen at": "Seen at",
    "select columns to show": "Select columns to show",
    "show details": {
      "companies": "Show company details",
      "drivers": "Show driver details",
      "integrations": "Show integration details",
      "vehicles": "Show vehicle details"
    },
    "status": "Status",
    "today": "Today",
    "updated at": "Updated at",
    "vehicle": "Vehicle",
    "vehicle name": "Vehicle name",
    "vehicle number": "VRN",
    "vehicles": "Vehicles"
  },
  "Tabs": {
    "analysis providers": "Analysis providers",
    "api": "API",
    "invitations": "Invitations",
    "sftp": "SFTP",
    "users": "Users"
  },
  "Tooltip": {
    "delete company action": "One or more selected companies have child companies and cannot be deleted. First delete all the child companies, in order to delete the selected ones.",
    "no action permission": "You do not have permission for this action",
    "parent company": "Maximum allowed company levels in a company tree is {{maxAllowedLevels}}. Company “{{companyName}}” is at the {{maxAllowedLevels}}th level and cannot have any child companies added."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "To add a new company card, click the highlighted “<strong>Add new</strong>” button. When the add company screen appears, fill in the necessary fields, and click the “<strong>Save</strong>” button to finish.\n\nNote: The Company Card ID can be found in the Company Card Authenticator, under the Card ID column.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Add a new company card"
        },
        "final step": {
          "content": "All added cards and their details will be listed under “Company cards”.\n\nNote: You can always repeat this tutorial by going to “Settings” - “Tutorials”. \n\nClick “<strong>Finish</strong>” to complete the tutorial.",
          "title": "Company card details"
        },
        "first step": {
          "content": "Before you add a company card in TachoSync, make sure you have the Company Card Authenticator downloaded and installed. This can be done anytime from the Settings menu.\n\nCompany Card Authenticator will read and show the information from company cards inserted in your card reader and enable remote authentication.\n\nClick “<strong>Get started</strong>” to begin.",
          "title": "Company Card Authenticator"
        },
        "fourth step": {
          "content": "On the right side, you can see the company details panel. Here you can find all the information about the company created.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Company details"
        },
        "second step": {
          "content": "Using the left sidebar, navigate to the highlighted <strong>Companies</strong> page.",
          "title": "Companies page"
        },
        "third step": {
          "content": "To see the company cards screen, you must first click on one of the companies.\n\nFor this tutorial, select the highlighted company, which is at the top of the table.",
          "title": "Choose a company"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "To add a new company card, click the highlighted “Add new” button. When the add company screen appears, fill in the necessary fields, and click the “Save” button to finish.\n\nNote: The Company Card ID can be found in the Company Card Authenticator, under the Card ID table column.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Add a new company card"
        },
        "final step": {
          "content": "All added cards will be listed under the highlighted “Company cards”. There you will see the card status, validity date and ID.\n\nNote: You can always repeat this tutorial by going to “Settings” - “Tutorials”. \n\nClick “<strong>Finish</strong>” to complete the tutorial.",
          "title": "Company card details"
        },
        "first step": {
          "content": "First we need to navigate to the <strong>Companies page</strong>, which is located inside the menu, on the top right.\n\nClick the highlighted area to open the <strong>menu</strong>.",
          "title": "Open the menu"
        },
        "fourth step": {
          "content": "Here you can find all information about the created company.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Company details"
        },
        "second step": {
          "content": "To open the <strong>Companies page</strong>, click on the highlighted area.",
          "title": "Companies page"
        },
        "third step": {
          "content": "Here you can see the list of all companies.\nIn order to see company cards of one, open the <strong>company details</strong> screen by clicking on the highlighted button.",
          "title": "More details"
        }
      },
      "name": "Add company card"
    },
    "add vehicle": {
      "first step": {
        "content": "In order to apply a schedule, you need to have at least one vehicle added.\n\nLet’s add a vehicle, by pressing the highlighted “<strong>Add vehicle</strong>” button.\n\nIn the next screen, fill in all the necessary fields and press the “<strong>Add</strong>” button to finish adding a vehicle.",
        "title": "No vehicles added"
      },
      "name": "Add vehicle"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "After you have selected a schedule, the “Apply” button will become enabled.\n\nClick the “<strong>Apply</strong>” button.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Select a schedule to apply"
        },
        "final step": {
          "content": "When a schedule is successfully applied to a vehicle, data downloading will begin according to the scheduled time.\n\nAll schedules applied to a vehicle or driver will be displayed in the highlighted “More details” panel.\n\nClick “<strong>Finish</strong>” to complete the tutorial.",
          "title": "Schedule successfully applied"
        },
        "first step": {
          "content": "Vehicle schedules are located on the Vehicles page, while drivers schedules are located on the Drivers page.\n\nSince the process is similar on both pages, for this tutorial, select the highlighted “<strong>Vehicles</strong>” page.",
          "title": "Vehicles or Drivers schedule"
        },
        "fourth step": {
          "content": "Click on a schedule to apply it to the selected vehicle(s).\n\nClick “<strong>Next</strong>” to continue",
          "title": "Select a schedule to apply"
        },
        "second step": {
          "content": "Before applying a schedule, select one or more vehicles.\n\nFor this tutorial, select the <strong>first vehicle in the table </strong> by clicking the highlighted button.",
          "title": "Select a vehicle"
        },
        "third step": {
          "content": "Now that you have a vehicle selected, the “Schedules” button will become enabled.\n\nClick the highlighted “<strong>Schedules</strong>” button to continue.",
          "title": "Open schedules"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Now that you have a vehicle selected, the Schedules button should become highlighted.\n\nClick the highlighted “<strong>Schedules</strong>” button to continue.",
          "title": "Open schedules"
        },
        "final step": {
          "content": "When a schedule is successfully applied to a vehicle, data downloading will begin according to the scheduled time.\nAll schedules applied to a vehicle or driver will be displayed in the highlighted “<strong>More details</strong>” panel.\n\nClick “<strong>Finish</strong>” to complete the tutorial.",
          "title": "Schedule successfully applied"
        },
        "first step": {
          "content": "Vehicle schedules are located on the Vehicles page, while drivers schedules are located on the Drivers page.\n\nSince the process is similar on both pages, for this tutorial let’s select the highlighted “<strong>Vehicles page</strong>”.",
          "title": "Vehicles or Drivers schedule"
        },
        "fourth step": {
          "content": "For this tutorial, let’s select the first vehicle in the table, by clicking on the highlighted button.",
          "title": "Select a vehicle"
        },
        "second step": {
          "content": "Since the process is similar on both pages, for this tutorial let’s select the highlighted “<strong>Vehicles page</strong>”.",
          "title": "Vehicles page"
        },
        "seventh step": {
          "content": "After you’ve selected a schedule, the highlighted “<strong>Apply</strong>” button will become enabled. Clicking it will apply the schedule to the selected vehicle.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Select a schedule to apply"
        },
        "sixth step": {
          "content": "After selecting the vehicle, you can choose a schedule to apply by clicking on it.\n\nClick “<strong>Next</strong>” to continue",
          "title": "Select a schedule to apply"
        },
        "third step": {
          "content": "You must first select one or more vehicles, before applying a schedule to them.\nTo begin, click the highlighted “<strong>Select rows</strong>” button.",
          "title": "Open selection tool"
        }
      },
      "name": "Apply schedule"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "In the top menu, the company selector allows choosing a company you wish to interact with in TachoSync.\nThis is needed when you manage more than one company.\n\nClick the <strong>highlighted</strong> button to open the company selector.",
          "title": "Open company selector"
        },
        "second step": {
          "content": "The Company selector screen allows you to select a specific company to work with. In other menus, you will only see resources related to the selected company. Signing out of TachoSync will always save the last used selection.",
          "title": "Company selector"
        }
      },
      "mobile": {
        "first step": {
          "content": "In the top menu, the company selector allows choosing a company you wish to interact with in TachoSync.\nThis is needed when you manage more than one company.\n\nClick the <strong>highlighted</strong> button to open the company selector.",
          "title": "Open company selector"
        },
        "second step": {
          "content": "The Company selector screen allows you to select a specific company to work with. In other menus, you will only see resources related to the selected company. Signing out of TachoSync will always save the last used selection.",
          "title": "Company selector"
        }
      },
      "name": "Company selector"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Once a schedule is created, it needs to be applied to selected vehicles or drivers. See the “<strong>Apply schedule</strong>” tutorial on how to apply schedules.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Schedule not applied"
        },
        "final step": {
          "content": "Congratulations, you have successfully learned how to create a schedule.\n\nNext, learn how to apply a schedule to selected items.\n\nClick “<strong>Finish</strong>” to complete the tutorial.",
          "title": "Create a schedule - completed"
        },
        "first step": {
          "content": "A schedule is a pre-set plan that automatically downloads tachograph data from your vehicles or drivers at specified times and intervals. By setting a start date, time, and frequency (such as daily), the schedule ensures that data is consistently collected without the need for manual actions.\n\nClick “<strong>Get started</strong>” to begin.",
          "title": "What is a schedule?"
        },
        "fourth step": {
          "content": "In this screen, you can create, edit, pause, or remove schedules. The first spot is always reserved for the Global schedule, which cannot be removed.",
          "title": "Schedules"
        },
        "second step": {
          "content": "Vehicle schedules are located on the “Vehicles” page. Driver schedules are located on the “Drivers” page.\n\nSince the process is similar on both pages, for this tutorial, select the highlighted “<strong>Vehicles</strong>” page.",
          "title": "Vehicles or Drivers schedule"
        },
        "third step": {
          "content": "A schedule can be created and edited in the Schedules window at any time, regardless of whether any vehicles or drivers have been added.\n\nClick the highlighted “<strong>Schedules</strong>” button to continue.",
          "title": "Open schedules"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "In this screen you can create, edit, pause, or remove any created schedules. The first spot is always reserved for the Global schedule, which cannot be removed.",
          "title": "Schedules"
        },
        "final step": {
          "content": "Congratulations, you've successfully learned how to create a schedule.\n\next, learn how to apply a schedule to selected items.\n\nClick “<strong>Finish</strong>” to complete the tutorial.",
          "title": "Create a schedule - completed"
        },
        "first step": {
          "content": "A schedule is a pre-set plan that automatically downloads tachograph data from your vehicles or drivers at specified times and intervals. By setting a start date, time, and frequency (such as daily), the schedule ensures that data is consistently collected without the need for manual intervention.\n\nClick “<strong>Get started</strong>” to begin.",
          "title": "What is a schedule?"
        },
        "fourth step": {
          "content": "A schedule can be created and edited in the Schedules window at any time, regardless of whether any vehicles or drivers have been added.\n\nClick the highlighted “<strong>Schedules</strong>” button to continue.",
          "title": "Open schedules"
        },
        "second step": {
          "content": "Vehicle schedules are located on the Vehicles page, while drivers schedules are located on the Drivers page.\n\n To navigate to these pages, let’s first open the <strong>menu</strong>.",
          "title": "Vehicles or Drivers schedule"
        },
        "sixth step": {
          "content": "Once a schedule is created, it needs to be applied to selected vehicles or drivers. How to perform this action is explained in another tutorial “<strong>Apply schedule</strong>”.\n\nClick “<strong>Next</strong>” to continue.",
          "title": "Schedule not applied"
        },
        "third step": {
          "content": "Since the process is similar on both pages, for this tutorial let’s select the highlighted “<strong>Vehicles page</strong>”",
          "title": "Vehicles page"
        }
      },
      "name": "Create schedule"
    }
  }
}
